export default __webpack_public_path__ + "assets/93bc338a346469f4708cc503fb58031b.svg";